<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการบัตรเติมเกม
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="add()">
                            <i class="material-icons">add_box</i>
                            <span>สร้างบัตรเติมเกม</span>
                        </button>

                    </div>
                    <div class="col-sm-5 col-search"></div>
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อบัตรเติมเกม เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-1 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
                <div class="row ">
                    <div class="col-sm-12 " style="text-align: right;">
                        <img src="static/images/excel.png" class="excel-icon" alt="download excel"
                            style="margin-right: 15px;cursor: pointer;" @click="download()" />
                    </div>
                </div>
                <div class="body table-responsive" style="width:100%">
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th">รูปภาพ</th>
                                    <th class="fn-th">ชื่อบัตรเติมเกม</th>
                                    <th class="fn-th">บริษัท</th>
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th">แก้ไข</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1"></td>
                                    <td style="text-align: center;">

                                        <img :src="item.image" :alt="item.name"  style="width: 100px;" v-if="item.image != null"/>

                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.name }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.company_name }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.status == 1 ? 'Active' : 'Inactive' }}</span>
                                    </td>
                                   

                                    <td>
                                        <span @click="edit(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span @click="del(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        <div class="modal fade" id="mobile-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างบัตรเติมเกม</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top:20px">
                        <div class=" col-sm-2"></div>
                        <div class="col-sm-10" style="text-align: center;">
                            
                             <div style="margin-top: 15px;" v-if="mobile.image">
                                <img :src="mobile.image" class="img-box" alt="i-mobile"/>
                                <div style="margin-top: 10px;">
                                <i class="material-icons del-image-icon" @click="deleteImage()">clear</i>
                                </div>
                             </div>
                             <div v-else>
                                <button class="file-upload-btn" type="button" @click="uploadClick()">+เพิ่มรูปภาพ</button>
                                 <input class="file-upload-input" type='file' ref="uploadFile"
                                @change="handleFilesUpload(this);" accept="image/*" />
                            </div>
                        </div>

                    </div>


                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>บริษัท</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <select v-model="company_id" class="form-control  show-tick fn-required" :disabled="company_id > 0">
                                <option value="">เลือกบริษัทจากWepay</option>
                                 <option v-for="(value,index) in companies" :key="'mobile-key-' + index" :value="value.company_id" v-html="value.company_name"></option>
                            </select>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ชื่อบัตรเติมเกม</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <input type="text" class="form-control fn-required" v-model="mobile.name" placeholder="กรุณากรอกชื่อบัตรเติมเกม">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>สถานะ</span>
                        </div>
                        <div class="col-sm-6">
                            <select class="form-control  show-tick fn-required" v-model="mobile.status">
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import WepayService from '../../service/WepayService'
import CardService from '../../service/CardService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "CardManage",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            page: 1,
            perpage: 25,
            total: 0,
            pages: 0,
            items: [],
            company_id: "",
            companies: [],
            mobile: {},
            key: "",
            item: [],
            file: null,
            searching: false,
            loading: false,
            search_params: {}
        }
    },
    async created() {
        await this.getData()
        await this.search(1)
    },
    mounted() {

    },
    methods: {
         async getData  () {
            let response = await WepayService.get('cashcard')
          
            if(response.status){
                this.companies = response.result
            }
        },
        async search(p = 0) {
            this.loading = true
            if (p > 0) {
                this.page = p
            }
            let response = await CardService.search(this.key, this.page, this.perpage)
          
            if (response.status) {
                let { page, perpage, total, pages, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data

            }
            this.loading = false
        },
        reset(p = 1) {
            this.key = ""
            this.search(p)
        },
        add() {
            this.company_id = ""
            this.mobile = {
                id: 0,
                company_id: "",
                company_name: "",
                name: "",
                image: "",
                status: "1",
                created_by: this.user.id
            }
            $('#mobile-modal').modal('show')
        },
        edit(id) {
            
            let mobile = this.items.find(x => x.id == id)
            this.mobile = { ...mobile, updated_by: this.user.id }
            this.company_id = mobile.company_id
     
            $('#mobile-modal').modal('show')
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            if (this.mobile.id == 0) {
                await this.create()
            }
            else {
                await this.update()
            }

            $('#mobile-modal').modal('hide')
        },
        validate() {
                if (!this.company_id) {
                    alertBox.error("กรุณาเลือกบริษัท")
                    return false
                }
            if (!this.mobile.name) {
                alertBox.error("กรุณากรอกชื่อค่ายมือถือ")
                return false
            }
            

            return true
        },
        async create() {
            try {
                let company = this.companies.find(x => x.company_id == this.company_id)
                let formData = new FormData();
                formData.append('company_id', company.company_id );
                formData.append('company_name',company.company_name);
                formData.append('name', this.mobile.name);
                formData.append('status', this.mobile.status);
                formData.append('created_by', this.mobile.created_by);
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }

                let response = await CardService.create(formData)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async update() {
            try {
                let formData = new FormData();
                let company = this.companies.find(x => x.company_id == this.company_id)
                formData.append('id', this.mobile.id);

                formData.append('company_id', company.company_id );
                formData.append('company_name', company.company_name);
                formData.append('name', this.mobile.name);
                formData.append('image', this.mobile.image);
                formData.append('status', this.mobile.status);
                formData.append('updated_by', this.user.id);
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }
                
                let response = await CardService.update(formData)
              
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async del(id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    id: id,
                    updated_by: this.user.id
                }
                let response = await CardService.delete(data)

                if (response.status) {
                    this.reset()
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        },
         uploadClick(){
            this.$refs.uploadFile.click()
        },
        handleFilesUpload() {
             let uploadedFiles = this.$refs.uploadFile.files;
            this.mobile.image = URL.createObjectURL(uploadedFiles[0])
            this.file = uploadedFiles[0]
            this.$refs.uploadFile.value = ""
        },
        validateFile(file) {
         
            if (file.size > this.max_file_size) {
                let size = this.max_file_size / 1000000
                alertBox.error(`กรุณาเลือกขนาดขนาดไฟล์ ไม่เกิน ${size} mb`)
                return false
            }

            if (!file.type) {
                alertBox.error(`ชนิดของไฟล์ไม่ถูกต้อง<br>ไม่อนญาตไฟล์ ${file.name} ขึ้นสู่ระบบ`)
                return false
            }

            let ext = file.name.split('.').reverse()[0].toLowerCase()
            if (!this.file_extensions.includes(ext)) {
                alertBox.error(`ชนิดของไฟล์ไม่ถูกต้อง<br>ไม่อนญาตไฟล์ ${file.name} ขึ้นสู่ระบบ`)
                return false
            }

            return true
        },
        async deleteImage() {
            const result = await alertBox.confirm('Are you sure to delete?')
            
            if (result) {
                this.mobile.image = ""
            }

        },

    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
.clear-img{
        cursor: pointer;
        color:red;
        font-size:16px;
        vertical-align: middle;
    }
    .img-box{
        cursor: zoom-in;
        max-height : 160px;
    }
    
    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-btn {
        width: 100%;
        color: #2196f3;
        background: #fff;
        border: 1px dashed #2196f3;
        padding: 10px;
        border-radius: 4px;
        /* border-bottom: 4px solid #15824B; */
        transition: all .2s ease;
        outline: none;
        text-transform: uppercase;
        font-weight: 700;
    }

    .file-upload-btn:hover {
        background: #2196f3;
        color: #ffffff;
        transition: all .2s ease;
        cursor: pointer;
    }

    .file-upload-btn:active {
        border: 0;
        transition: all .2s ease;
    }

    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-content {
        display: none;
        text-align: center;
    }

    .file-upload-input {
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
        cursor: pointer;
    }   

    .image-title-wrap {
        padding: 0 15px 15px 15px;
        color: #222;
    }

    .file-upload-image {
        max-height: 200px;
        max-width: 200px;
        margin: auto;
        padding: 20px;
    }
    .del-image-icon{
        color: red;
        cursor: pointer;
        font-size: 21px;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/Manage/Card.vue